import React from 'react';
import ScrollableTabs from "../../../../../../../../../../components/Common/ScrollableTabs";
import MultistoreMenuTab from "./MultistoreMenuTab";

interface Props {
    menus: Record<string, any>[];
    menuId: number;
    setMenu: React.Dispatch<React.SetStateAction<Record<string, any> | undefined>>;
}

const MultistoreMenuTabs = ({menus, menuId, setMenu}: Props) => {
    if (menus.length < 2) return <></>;

    const sortedMenus = [...menus].sort((a, b) => a.name.localeCompare(b.name));

    return (
        <div className="menu-tabs-container">
            <ScrollableTabs hideScrollbars={false} scrollStep={60}>
                {sortedMenus.map((menu: Record<string, any>) => (
                    <MultistoreMenuTab key={menu.id} name={menu.name} active={Number(menuId) === menu.id}
                                       onClick={() => setMenu(menu)}
                    />
                ))}
            </ScrollableTabs>
        </div>
    )
}

export default MultistoreMenuTabs;